import { render, staticRenderFns } from "./addComment.vue?vue&type=template&id=28f46ec4&scoped=true"
import script from "./addComment.vue?vue&type=script&lang=js"
export * from "./addComment.vue?vue&type=script&lang=js"
import style0 from "./addComment.vue?vue&type=style&index=0&id=28f46ec4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f46ec4",
  null
  
)

export default component.exports